import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 判断哪些页面不需要加公用的头部尾部
        includeShow: true,
        // tab切换
        tabIndex: 0,
        callme: 0

    },
    mutations: {
        setIncludeShow (state, payLoad) {
            state.includeShow = payLoad
        },
        setTabIndex (state, payLoad) {
            state.tabIndex = payLoad
        },
        callme (state, payLoad) {
            state.callme = payLoad
        }
    },
    getters: {
        includeShow: state => state.includeShow,
        tabIndex: state => state.tabIndex,
        callme: state => state.callme
    },
    // 所有异步操作
    actions: {
    },
    modules: {
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js